import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NewsComponent} from './news/news.component';
import {AppRoutingModule} from '../../app-routing.module';
import {SharedModule} from '../shared/shared.module';
import {NgxLinkifyjsModule} from "ngx-linkifyjs";

@NgModule({
  declarations: [
    NewsComponent,
  ],
  imports: [
    SharedModule,
    AppRoutingModule,
    CommonModule,
    NgxLinkifyjsModule
  ],
  exports: [NewsComponent]
})
export class NewsModule {
}
